import React from 'react'
import { Text, StyleSheet } from 'react-native'

import PropTypes from 'prop-types'

export const commonStyle = StyleSheet.create({
  corner: {
    borderRadius: 20
  },
  dropShadow: {
    boxShadow: '0 5px 8px 7px rgba(0, 0, 0, 0.4)'
  },
  h1: {
    fontFamily: 'OpenSans_700Bold',
    fontSize: 30,
    fontWeight: 'bold',
    userSelect: 'none',
    draggable: 'false'
  },
  h2: {
    fontFamily: 'OpenSans_700Bold',
    fontSize: 24,
    fontWeight: 'bold',
    userSelect: 'none',
    draggable: 'false'
  },
  h3: {
    fontFamily: 'OpenSans_700Bold',
    fontSize: 20,
    fontWeight: 'bold',
    paddingTop: 20,
    userSelect: 'none',
    draggable: 'false'
  },
  h4: {
    fontFamily: 'OpenSans_700Bold',
    fontSize: 14,
    fontWeight: 'bold',
    paddingTop: 10,
    userSelect: 'none',
    draggable: 'false'
  },
  displayText: {
    fontFamily: 'OpenSans_400Regular',
    fontSize: 20,
    userSelect: 'none',
    draggable: 'false',
    color: 'rgb(66 66 66)',
    paddingTop: 20
  },
  displayTextSmall: {
    fontFamily: 'OpenSans_400Regular',
    fontSize: 14,
    userSelect: 'none',
    draggable: 'false',
    color: 'rgb(66 66 66)',
    paddingTop: 10
  },
  displayTextSmall0: {
    fontFamily: 'OpenSans_400Regular',
    fontSize: 14,
    userSelect: 'none',
    draggable: 'false',
    color: 'rgb(66 66 66)',
    paddingTop: 0
  },
  displayText10: {
    fontFamily: 'OpenSans_400Regular',
    fontSize: 14,
    userSelect: 'none',
    draggable: 'false',
    color: 'rgb(66 66 66)',
    paddingTop: 10
  },
  displayText0: {
    fontFamily: 'OpenSans_400Regular',
    fontSize: 14,
    userSelect: 'none',
    draggable: 'false',
    color: 'rgb(66 66 66)',
    paddingTop: 0
  },
  link: {
    fontFamily: 'OpenSans_400Regular',
    fontSize: 14,
    userSelect: 'none',
    draggable: 'false',
    color: '#3b6876',
    paddingTop: 0
  }
})

export const H1 = ({ children }) => {
  return (
    <Text style={commonStyle.h1}>
      {children}
    </Text>
  )
}

H1.propTypes = {
  children: PropTypes.node.isRequired
}

export const H2 = ({ children }) => {
  return (
    <Text style={commonStyle.h2}>
      {children}
    </Text>
  )
}

H2.propTypes = {
  children: PropTypes.node.isRequired
}

export const H3 = ({ children }) => {
  return (
    <Text style={commonStyle.h3}>
      {children}
    </Text>
  )
}

H3.propTypes = {
  children: PropTypes.node.isRequired
}

export const TextSmall = ({ children }) => {
  return (
    <Text style={commonStyle.displayTextSmall}>
      {children}
    </Text>
  )
}

TextSmall.propTypes = {
  children: PropTypes.node.isRequired
}

export const TextSmall0 = ({ children }) => {
  return (
    <Text style={commonStyle.displayTextSmall0}>
      {children}
    </Text>
  )
}

TextSmall0.propTypes = {
  children: PropTypes.node.isRequired
}

export const TextDisplay = ({ children }) => {
  return (
    <Text style={commonStyle.displayText}>
      {children}
    </Text>
  )
}

TextDisplay.propTypes = {
  children: PropTypes.node.isRequired
}
